//@ts-ignore
import React, { RefObject, useEffect, useRef, useState } from 'react';
import { Box } from 'src/components/mui';
import { Preview, ReelBar } from './styled';

export const CustomReel = ({
  reels,
  showcaseTour,
  tourId,
  awsUrl,
  loadModel,
  bottomBarWidth,
  handleOpenVideo,
}: any) => {
  const [reelStep, setReelStep] = useState(-1);
  const scrollRef: RefObject<HTMLDivElement> = useRef(null);

  const scrollHorizontally = (e: any) => {
    if (scrollRef.current) {
      e = window.event || e;
      const delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail));
      scrollRef.current.scrollLeft -= delta * 10; // Multiplied by 40
    }
  };

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.addEventListener('DOMMouseScroll', scrollHorizontally, false);
      scrollRef.current.addEventListener('mousewheel', scrollHorizontally, false);
    }
  }, []);

  const filteredReel = reels?.filter((r: any) => !r.hide);

  return (
    <ReelBar id="reel-bar" ref={scrollRef} onWheel={scrollHorizontally} width={bottomBarWidth}>
      <div className="scroll-div reels-block" style={{ width: `${170 * filteredReel?.length}px` }}>
        {filteredReel?.map((p: any, i: number) => (
          <Preview
            key={i}
            onClick={() => {
              if (p.url || p.tag || p.panoramaId) {
                loadModel({
                  title: p.title,
                  url: p.url,
                  type: p.type,
                  tag: p.tag,
                  panoramaId: p.panoramaId,
                  tour: showcaseTour,
                  iframeSettings: p.iframeSettings,
                });
              }
              if (p.videoUrl) {
                handleOpenVideo(p);
              }
              setReelStep(i);
            }}
            className={reelStep === i ? 'preview active' : 'preview'}
            style={
              p.imageId
                ? {
                    backgroundImage: `url(${awsUrl}/tours/${tourId}/images/${p?.image?.url})`,
                  }
                : p.libraryImageId && p?.image?.filePath
                  ? {
                      backgroundImage: `url(${awsUrl}/${p?.image?.filePath})`,
                    }
                  : {}
            }
          >
            {p.type === 'matterport' ||
              p.type === 'matterport-instant' ||
              (p.type === 'treedis' && <i className="fas fa-walking" />)}
            <Box
              component="span"
              sx={{
                color: '#fff',
                position: 'absolute',
                bottom: '2px',
                left: '0',
                fontSize: '14px',
                textShadow: '0 1px 5px rgb(0 0 0 / 50%)',
                width: '100%',
                textAlign: 'center',
              }}
            >
              {p.label}
            </Box>
            {p.videoUrl && (
              <Box width="100%" height="100%" sx={{ pointerEvents: 'none' }}>
                <iframe
                  src={p.videoUrl}
                  allow="autoplay; fullscreen"
                  allowFullScreen
                  title="Embedded video"
                  style={{
                    width: '100%',
                    height: '100%',
                  }}
                />
              </Box>
            )}
          </Preview>
        ))}
      </div>
    </ReelBar>
  );
};
// }
